module.exports = __webpack_public_path__ + "img/sup_wallet_5.e573506c.jpg";